import { useEffect } from "react";

/**
 * Global screen wake lock - keeps the display on for as long as the user
 * is on Smartasaurus (reading, listening, watching, playing). Re-acquires
 * automatically when the tab regains visibility (browsers auto-release on hide).
 *
 * Silent no-op where Wake Lock API is unsupported (older iOS Safari).
 */
export function useSiteWakeLock() {
  useEffect(() => {
    let lock: any = null;
    let cancelled = false;

    const acquire = async () => {
      try {
        if (cancelled) return;
        if (!("wakeLock" in navigator)) return;
        if (document.visibilityState !== "visible") return;
        if (lock) return;
        lock = await (navigator as any).wakeLock.request("screen");
        lock?.addEventListener?.("release", () => { lock = null; });
      } catch {
        /* denied / not supported - ignore */
      }
    };

    const onVis = () => {
      if (document.visibilityState === "visible") void acquire();
    };

    void acquire();
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", onVis);

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("focus", onVis);
      try { lock?.release?.(); } catch { /* ignore */ }
      lock = null;
    };
  }, []);
}
